import * as Types from '../../../data/workbench-api/generated/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ManageSsoAuthFragment = { __typename?: 'AppClient', nodeId: string, name?: string | null, appClientId: string, created: string, updated: string, ssoClaimMapping: unknown };

export type ListAppClientsQueryVariables = Types.Exact<{
  organisationId: Types.Scalars['String']['input'];
}>;


export type ListAppClientsQuery = { __typename?: 'Query', appClients?: { __typename?: 'AppClientsConnection', nodes: Array<{ __typename?: 'AppClient', nodeId: string, name?: string | null, appClientId: string, created: string, updated: string, ssoClaimMapping: unknown }> } | null };

export type UpdateSsoMappingMutationVariables = Types.Exact<{
  appClientId: Types.Scalars['String']['input'];
  organisationId: Types.Scalars['String']['input'];
  mapping?: Types.InputMaybe<Types.Scalars['JSON']['input']>;
}>;


export type UpdateSsoMappingMutation = { __typename?: 'Mutation', updateAppClient?: { __typename?: 'UpdateAppClientPayload', appClient?: { __typename?: 'AppClient', nodeId: string, name?: string | null, appClientId: string, created: string, updated: string, ssoClaimMapping: unknown } | null } | null };

export type ListGroupsQueryVariables = Types.Exact<{
  organisationId: Types.Scalars['String']['input'];
}>;


export type ListGroupsQuery = { __typename?: 'Query', groups?: { __typename?: 'GroupsConnection', nodes: Array<{ __typename?: 'Group', name: string, id: string }> } | null };

export const ManageSsoAuthFragmentDoc = gql`
    fragment ManageSSOAuth on AppClient {
  nodeId
  name
  appClientId
  created
  updated
  ssoClaimMapping
}
    `;
export const ListAppClientsDocument = gql`
    query ListAppClients($organisationId: String!) {
  appClients(condition: {organisationId: $organisationId}) {
    nodes {
      ...ManageSSOAuth
    }
  }
}
    ${ManageSsoAuthFragmentDoc}`;

/**
 * __useListAppClientsQuery__
 *
 * To run a query within a React component, call `useListAppClientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListAppClientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListAppClientsQuery({
 *   variables: {
 *      organisationId: // value for 'organisationId'
 *   },
 * });
 */
export function useListAppClientsQuery(baseOptions: Apollo.QueryHookOptions<ListAppClientsQuery, ListAppClientsQueryVariables> & ({ variables: ListAppClientsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListAppClientsQuery, ListAppClientsQueryVariables>(ListAppClientsDocument, options);
      }
export function useListAppClientsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListAppClientsQuery, ListAppClientsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListAppClientsQuery, ListAppClientsQueryVariables>(ListAppClientsDocument, options);
        }
export function useListAppClientsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListAppClientsQuery, ListAppClientsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListAppClientsQuery, ListAppClientsQueryVariables>(ListAppClientsDocument, options);
        }
export type ListAppClientsQueryHookResult = ReturnType<typeof useListAppClientsQuery>;
export type ListAppClientsLazyQueryHookResult = ReturnType<typeof useListAppClientsLazyQuery>;
export type ListAppClientsSuspenseQueryHookResult = ReturnType<typeof useListAppClientsSuspenseQuery>;
export type ListAppClientsQueryResult = Apollo.QueryResult<ListAppClientsQuery, ListAppClientsQueryVariables>;
export const UpdateSsoMappingDocument = gql`
    mutation UpdateSsoMapping($appClientId: String!, $organisationId: String!, $mapping: JSON) {
  updateAppClient(
    input: {appClientId: $appClientId, organisationId: $organisationId, patch: {ssoClaimMapping: $mapping}}
  ) {
    appClient {
      ...ManageSSOAuth
    }
  }
}
    ${ManageSsoAuthFragmentDoc}`;

/**
 * __useUpdateSsoMappingMutation__
 *
 * To run a mutation, you first call `useUpdateSsoMappingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSsoMappingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSsoMappingMutation, { data, loading, error }] = useUpdateSsoMappingMutation({
 *   variables: {
 *      appClientId: // value for 'appClientId'
 *      organisationId: // value for 'organisationId'
 *      mapping: // value for 'mapping'
 *   },
 * });
 */
export function useUpdateSsoMappingMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSsoMappingMutation, UpdateSsoMappingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSsoMappingMutation, UpdateSsoMappingMutationVariables>(UpdateSsoMappingDocument, options);
      }
export type UpdateSsoMappingMutationHookResult = ReturnType<typeof useUpdateSsoMappingMutation>;
export type UpdateSsoMappingMutationResult = Apollo.MutationResult<UpdateSsoMappingMutation>;
export type UpdateSsoMappingMutationOptions = Apollo.BaseMutationOptions<UpdateSsoMappingMutation, UpdateSsoMappingMutationVariables>;
export const ListGroupsDocument = gql`
    query ListGroups($organisationId: String!) {
  groups(condition: {organisationId: $organisationId}) {
    nodes {
      name
      id
    }
  }
}
    `;

/**
 * __useListGroupsQuery__
 *
 * To run a query within a React component, call `useListGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListGroupsQuery({
 *   variables: {
 *      organisationId: // value for 'organisationId'
 *   },
 * });
 */
export function useListGroupsQuery(baseOptions: Apollo.QueryHookOptions<ListGroupsQuery, ListGroupsQueryVariables> & ({ variables: ListGroupsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListGroupsQuery, ListGroupsQueryVariables>(ListGroupsDocument, options);
      }
export function useListGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListGroupsQuery, ListGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListGroupsQuery, ListGroupsQueryVariables>(ListGroupsDocument, options);
        }
export function useListGroupsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListGroupsQuery, ListGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListGroupsQuery, ListGroupsQueryVariables>(ListGroupsDocument, options);
        }
export type ListGroupsQueryHookResult = ReturnType<typeof useListGroupsQuery>;
export type ListGroupsLazyQueryHookResult = ReturnType<typeof useListGroupsLazyQuery>;
export type ListGroupsSuspenseQueryHookResult = ReturnType<typeof useListGroupsSuspenseQuery>;
export type ListGroupsQueryResult = Apollo.QueryResult<ListGroupsQuery, ListGroupsQueryVariables>;